export const MIN_PASSWORD_LENGTH = 8;

export function getPasswordValidationError(password, { required = true } = {}) {
  if (typeof password !== "string") return "パスワードを入力してください";
  if (!password.length) return required ? "パスワードを入力してください" : "";
  if (!password.trim()) return "空白だけのパスワードは使用できません";
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `パスワードは${MIN_PASSWORD_LENGTH}文字以上で入力してください`;
  }
  return "";
}

